<span
  capraTooltip
  [tooltipIsDisabled]="tooltipIsDisabled"
  [tooltipInteractive]="false"
  [tooltipContent]="dateTooltip"
  tooltipPlacement="bottom"
  tooltipSize="regular-thin"
  data-test="time-value"
>{{ date | timeAgo: { format: this.format } }}</span>
